<script>


import TitleBannersOurProjects from "./TitleBannersOurProjects.vue";
import ActualObjects from "./ActualObjects.vue";
import OnlineFormMob from "../Other/OnlineFormMob.vue";
import OurServices from "../Main/OurServices.vue";
import FaqQues from "../Other/FaqQues.vue";
import BtnApplication from "../Other/BtnApplication.vue";
import OnlineForm from "../Other/OnlineForm.vue";

export default {
  inject: ["gsap"],
  name: "MainOurProjects",
  components: {
    OnlineForm,
    BtnApplication,
    FaqQues,
    OurServices,
    OnlineFormMob,
    ActualObjects,
    TitleBannersOurProjects

  },
  data() {
    return {
      actualObj:[
        {
          'img' : 'image/vostok/Liner_01.jpg',
          'house' : 'ЖК “ЛАЙНЕР”',
          'anchor' : "liner",
          'flow_bold' : '~1.2 млн рублей',
          'repair_bold' : '~4 млн рублей',
          'price_bold' : '~13 млн рублей*',
          "blue_block" : [
            {
              "title" : 'Стоимость управления объектом',
              "desc" : "<span class=\"ao-desc blue\"> От 5%</span><br>(в зависимости от услуг)"
            },
            {
              "title" : 'Коммунальные платежи',
              "desc" : "<span class=\"ao-desc blue\">~45 000 рублей</span> в год"
            },
            {
              "title" : 'Имущественный налог на недвижимость',
              "desc" : "<br><span class=\"ao-desc blue\">~13 000 рублей</span> в год"
            }
          ],
          'desc_block' : 'Комплекс апартаментов бизнес класса «Лайнер» расположен на Ходынское поле, вокруг расположены дома высокого класса. У него привлекательное расположение и интересная инфраструктура. Комплекс «Лайнер» состоит из двух корпусов – «Запад» и «Восток», проект разработан под руководством архитектора Хади Тегерани и решен в современном стиле: стильная цветовая, панорамное остекление, закрытый двор без машин, разная этажность. На первом этаже зданий расположены стрит ритейлы. В шаговой доступности от комплекса расположены станции метро "ЦСКА", 15 аптек, 8 вузов, 13 детсадов, 12 магазинов, 17 спортивных площадок. Рядом парки «Ходынское поле», «Березовая роща» и «Чапаевский». На территории самого ЖК «Лайнер» находятся детские площадки и озелененные зоны отдыха. Также комплекс апартаментов оборудован подземным паркингом.'
        },
        {
          'img' : 'image/legend/img2.jpg',
          'house' : 'ЖК “Легендарный квартал”',
          'anchor' : "legend",
          'flow_bold' : '~1 млн рублей',
          'repair_bold' : '~3,5 млн рублей',
          'price_bold' : '~9 млн рублей*',
          "blue_block" : [
            {
              "title" : 'Стоимость управления объектом',
              "desc" : "<span class=\"ao-desc blue\"> От 5%</span><br>(в зависимости от услуг)"
            },
            {
              "title" : 'Коммунальные платежи',
              "desc" : "<span class=\"ao-desc blue\">~45 000 рублей</span> в год"
            },
            {
              "title" : 'Имущественный налог на недвижимость',
              "desc" : "<br><span class=\"ao-desc blue\">~10 000 рублей</span> в год"
            }
          ],
          'desc_block' : 'Апарт-комплекс «Легендарный квартал» находится в районе Останкино на северо-востоке Москвы рядом со станцией метро "Ботанический сад". Отсюда удобно добираться как на машине, так и на общественном транспорте. В 100 метрах от корпусов находится усадьба «Свиблово» с парком. До Главного ботанического сада РАН и нескольких других парков и скверов также можно дойти пешком. Очень низкая стоимости за квадратный метр, что делает этот объект недвижимости один из самых привлекательных для инвестиций. На первом этаже зданий расположены стрит ритейлы. Также комплекс апартаментов оборудован подземным паркингом.'
        },
        {
          'img' : 'image/tushino/dvizhenye-tushino-sl-1.jpg',
          'house' : 'ЖК “ДВИЖЕНИЕ. ТУШИНО”',
          'anchor' : "tushino",
          'flow_bold' : '~1 млн рублей',
          'repair_bold' : '~4 млн рублей',
          'price_bold' : '~10 млн рублей*',
          "blue_block" : [
            {
              "title" : 'Стоимость управления объектом',
              "desc" : "<span class=\"ao-desc blue\"> От 5%</span><br>(в зависимости от услуг)"
            },
            {
              "title" : 'Коммунальные платежи',
              "desc" : "<span class=\"ao-desc blue\">~45 000 рублей</span> в год"
            },
            {
              "title" : 'Имущественный налог на недвижимость',
              "desc" : "<br><span class=\"ao-desc blue\">~10 000 рублей</span> в год"
            }
          ],
          'desc_block' : 'Апарт-комплекс «Движение. Тушино» находится в районе Покровское-Стрешнево на северо-западе Москвы рядом со станциями метро "Спартак" и "Тушинская". Отсюда удобно выезжать в другие части столицы и за город. Спортсменов порадует водноспортивный комплекс «Буревестник» поблизости, а болельщиков — арена «Открытие». Недалеко находятся парки «Покровское-Стрешево», «Яблоневый сад», Щукинская набережная. На первом этаже зданий расположены стрит ритейлы.'
        },
        {
          'img' : 'image/heart/orig.jpeg',
          'house' : 'ЖК “Сердце Столицы”',
          'anchor' : "heart",
          'flow_bold' : '~1.2 млн рублей',
          'repair_bold' : '~4 млн рублей',
          'price_bold' : '~13 млн рублей*',
          "blue_block" : [
            {
              "title" : 'Стоимость управления объектом',
              "desc" : "<span class=\"ao-desc blue\"> От 5%</span><br>(в зависимости от услуг)"
            },
            {
              "title" : 'Коммунальные платежи',
              "desc" : "<span class=\"ao-desc blue\">~45 000 рублей</span> в год"
            },
            {
              "title" : 'Имущественный налог на недвижимость',
              "desc" : "<br><span class=\"ao-desc blue\">~10 000 рублей</span> в год"
            }
          ],
          'desc_block' : 'Жилой квартал бизнес-класса на берегу Москвы-реки в непосредственной близости от Сити. На территории находится собственный «зеленый остров» – парк площадью 2 Га и роща для прогулок. В пешей доступности находится МЦК «Шелепиха», удобный съезд на Звенигородское шоссе и ТТК. На первом этаже зданий расположены стрит ритейлы. Водный транспорт - причал "Шелепиха" до Киевского вокзала, зона отдыха Серебряный бор, крупнейший торговый центр Москвы Авиапарк. Также комплекс оборудован подземным паркингом.'
        },
      ],
      servicesLocal: [

        {
          'tarif' : 'Инвестиция',
          'img' : 'services1.png',
          'desc' : 'Предлагаем услуги по подбору и покупке ликвидного объекта  недвижимости и последующим управлением с целью увеличения финансового состояния.',
          'color_line1' : "blue",
          'color_line2' : "blue",
          'route' : '/investition'

        },
        {
          'tarif' : 'Управление',
          'img' : 'services3.png',
          'desc' : 'Предлагаем услуги по подготовке\n' +
              'объекта недвижимости к аренде с учетом эстетических и\n' +
              'маркетинговых принципов,\n' +
              'увеличивая арендную стоимость и экономя Ваше время.',
          'route' : '/management',
          'color_line1' : "blue",
          'color_line2' : "blue",
        },
        {
          'tarif' : 'Реинвестиция',
          'img' : 'services2.png',
          'desc' : 'Предлагаем услуги по продаже\n' +
              'имеющего объекта недвижимости\n' +
              'с последующей покупкой более\n' +
              'ликвидного объекта и\n' +
              'дальнейшим его управлением.',
          'route' : '/reinvestition',
          'color_line1' : "orange",
          'color_line2' : "green",
        },
        {
          'tarif' : 'Хоумстейджинг',
          'img' : 'services4.png',
          'desc' : 'Мы преображаем интерьер,\n' +
              'так, чтобы потенциальные арендаторы\n' +
              'и покупатели в него влюбились.\n' +
              'Это поможет сдать и продать объект\n' +
              'быстро и по более высокой цене.',
          'route' : '/home?filter=home',
          'color_line1' : "orange",
          'color_line2' : "green",
        },
        {
          'tarif' : 'Ремонт',
          'img' : 'services5.png',
          'desc' : 'Осуществляем полный комплекс\n' +
              'услуг по ремонту объекта недвижимости,\n' +
              'начиная от разработки\n' +
              'дизайн-проекта и заканчивая\n' +
              'мебелировкой помещений.',
          'route' : '/home?filter=home',
          'color_line1' : "orange",
          'color_line2' : "green",
        }
      ],
      faqList:[
        {
          "title": "Как заключается договор с собственником квартиры?",
          "desc" : "Мы заключаем с договор аренды на 11 мес. и далее уже можем его продлить. Договор заключается с нашей компанией, которая будет является арендатором. Квартиры мы сдаем по договору субаренды на основании заключенного договора аренды с вами как с собственником."
        },
        {
          "title": "Из каких этапов состоит пакет \"Инвестиция\"?",
          "desc" : "<span>\n" +
              "            Пакет “Инвестиция” состоит из следующих этапов:\n" +
              "          </span>\n" +
              "          <ul>\n" +
              "            <li>Консультация</li>\n" +
              "            <li>Подбор недвижимости</li>\n" +
              "            <li>Покупка недвижимости с сопровождением сделки</li>\n" +
              "            <li>Капитальный ремонт объекта недвижимости</li>\n" +
              "            <li>Управление недвижимостью</li>\n" +
              "          </ul>"
        },
        {
          "title": "Из каких этапов состоит пакет \"Реинвестиция\"?",
          "desc" : "<span>\n" +
              "            Пакет Реинвестиция” состоит из следующих этапов:\n" +
              "          </span>\n" +
              "          <ul>\n" +
              "            <li>Консультация</li>\n" +
              "            <li>Продажа текущего объекта недвижимости</li>\n" +
              "            <li>Подбор недвижимости</li>\n" +
              "            <li>Покупка недвижимости с сопровождением сделки</li>\n" +
              "            <li>Капитальный ремонт объекта недвижимости</li>\n" +
              "            <li>Управление недвижимостью</li>\n" +
              "          </ul>"
        },
        {
          "title": "Что такое хоумстейджинг?",
          "desc" : "С английского хоумстейджинг переводится как «домашняя постановка». По сути, это подготовка квартиры, в основе которой лежат дизайнерские и психологические приемы. Применяется, чтобы продать или сдать объект быстро и по более высокой цене"
        },
        {
          "title": "Какие сроки оказания услуг?",
          "desc" : "Срок оказания услуг зависит от выбранного пакета. Обычно мы подписываем договор на 3 месяца, однако по нашей практике этот срок составляет до 45 дней."
        },
        {
          "title": "Из каких этапов состоит пакет \"Управление\"?",
          "desc" : "<span>\n" +
              "            Пакет “Управление” состоит из следующих этапов:\n" +
              "         </span>\n" +
              "          <ul>\n" +
              "            <li>Консультация</li>\n" +
              "            <li>Хоумстейджинг объекта недвижимости</li>\n" +
              "            <li>Продвижение объекта недвижимости</li>\n" +
              "            <li>Ведение объекта недвижимости</li>\n" +
              "          </ul>"
        }
      ]
    }
  },
  mounted() {
    var element = $(".green-title")

    this.gsap.to(".green-title", {
      duration: 2,
      delay:2,
      scrollTrigger: {
        trigger: element, // Элемент, который будет триггером
        start: "top center", // Когда триггер сработает (например, когда верх элемента достигнет центра экрана)
        toggleClass: "active", // Добавляем/убираем класс "active" при срабатывании триггера
        once:true
      }
    });
    if (this.$route.hash) {
      const el = document.querySelector(this.$route.hash);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
}
</script>

<template>
  <div class="wrapper-content main-our-projects" id="main">
    <title-banners-our-projects></title-banners-our-projects>
    <actual-objects :actual-objects="actualObj"></actual-objects>
    <online-form></online-form>
    <our-services
        :services="servicesLocal"></our-services>
    <faq-ques
        :faqlist="faqList"
    ></faq-ques>
    <btn-application></btn-application>
  </div>
</template>

<style scoped>

</style>